export const adaSections = [
  {
    id: 1,
    name: 'Basic Details',
    fields: [
      {
        id: 'firstName',
        label: 'First Name',
        type: 'text',
        control_name: 'first_name',
        required: true,
        maxlength: 50,
        pattern: '^.*$'
      },
      {
        id: 'middleName',
        label: 'Middle Name',
        type: 'text',
        control_name: 'middle_name_initials',
        required: false,
        maxlength: 50,
        pattern: '^.*$'
      },
      {
        id: 'lastName',
        label: 'Last Name',
        type: 'text',
        control_name: 'last_name',
        required: true,
        maxlength: 50,
        pattern: '^.*$'
      },
      {
        id: 'date_of_birth',
        label: 'Date of Birth(MM/DD/YYYY)',
        type: 'datepicker',
        control_name: 'date_of_birth',
        required: true,
      },
      {
        id: 'gender',
        label: 'Gender',
        type: 'select',
        control_name: 'gender',
        required: true,
        options: [
          { key: 'M', value: 'Male' },
          { key: 'F', value: 'Female' }
        ]
      },
    ]
  },
  {
    id: 2,
    name: 'Contact Details',
    fields: [
      {
        id: 'phone_landline',
        label: 'Primary Phone Number',
        type: 'text',
        control_name: 'phone_landline',
        required: true,
        maxlength: 12,
        pattern: '^\\d{3}-\\d{3}-\\d{4}$'
      },
      {
        id: 'phone_mobile',
        label: 'Alternate Phone Number',
        type: 'text',
        control_name: 'phone_mobile',
        required: false,
        maxlength: 12,
        pattern: '^\\d{3}-\\d{3}-\\d{4}$'
      },
      {
        id: 'email',
        label: 'Email Address',
        type: 'text',
        control_name: 'email',
        required: false,
        maxlength: 100,
        pattern:'^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,4}$'
      },
    ]
  },
  {
    id: 3,
    name: 'Home Address',
    fields: [
      {
        id: 'home_street',
        label: 'Address',
        type: 'longtext',
        control_name: 'home_street',
        required: true,
        maxlength: 100,
        pattern: '^.*$'
      },
      {
        id: 'home_city',
        label: 'City',
        type: 'text',
        control_name: 'home_city',
        required: true,
        maxlength: 50,
        pattern: '^.*$'
      },
      {
        id: 'home_state',
        label: 'State',
        type: 'select',
        control_name: 'home_state',
        options: [
          {
              "key": "AL",
              "value": "Alabama"
          },
          {
              "key": "AK",
              "value": "Alaska"
          },
          {
              "key": "AZ",
              "value": "Arizona"
          },
          {
              "key": "AR",
              "value": "Arkansas"
          },
          {
              "key": "CA",
              "value": "California"
          },
          {
              "key": "CO",
              "value": "Colorado"
          },
          {
              "key": "CT",
              "value": "Connecticut"
          },
          {
              "key": "DE",
              "value": "Delaware"
          },
          {
              "key": "DC",
              "value": "District of Columbia"
          },
          {
              "key": "FL",
              "value": "Florida"
          },
          {
              "key": "GA",
              "value": "Georgia"
          },
          {
              "key": "HI",
              "value": "Hawaii"
          },
          {
              "key": "ID",
              "value": "Idaho"
          },
          {
              "key": "IL",
              "value": "Illinois"
          },
          {
              "key": "IN",
              "value": "Indiana"
          },
          {
              "key": "IA",
              "value": "Iowa"
          },
          {
              "key": "KS",
              "value": "Kansas"
          },
          {
              "key": "KY",
              "value": "Kentucky"
          },
          {
              "key": "LA",
              "value": "Louisiana"
          },
          {
              "key": "ME",
              "value": "Maine"
          },
          {
              "key": "MD",
              "value": "Maryland"
          },
          {
              "key": "MA",
              "value": "Massachusetts"
          },
          {
              "key": "MI",
              "value": "Michigan"
          },
          {
              "key": "MN",
              "value": "Minnesota"
          },
          {
              "key": "MS",
              "value": "Mississippi"
          },
          {
              "key": "MO",
              "value": "Missouri"
          },
          {
              "key": "MT",
              "value": "Montana"
          },
          {
              "key": "NE",
              "value": "Nebraska"
          },
          {
              "key": "NV",
              "value": "Nevada"
          },
          {
              "key": "NH",
              "value": "New Hampshire"
          },
          {
              "key": "NJ",
              "value": "New Jersey"
          },
          {
              "key": "NY",
              "value": "New York"
          },
          {
              "key": "NM",
              "value": "New Mexico"
          },
          {
              "key": "NC",
              "value": "North Carolina"
          },
          {
              "key": "ND",
              "value": "North Dakota"
          },
          {
              "key": "OH",
              "value": "Ohio"
          },
          {
              "key": "OK",
              "value": "Oklahoma"
          },
          {
              "key": "OR",
              "value": "Oregon"
          },
          {
              "key": "PA",
              "value": "Pennsylvania"
          },
          {
              "key": "RI",
              "value": "Rhode Island"
          },
          {
              "key": "SC",
              "value": "South Carolina"
          },
          {
              "key": "SD",
              "value": "South Dakota"
          },
          {
              "key": "TN",
              "value": "Tennessee"
          },
          {
              "key": "TX",
              "value": "Texas"
          },
          {
              "key": "UT",
              "value": "Utah"
          },
          {
              "key": "VT",
              "value": "Vermont"
          },
          {
              "key": "WA",
              "value": "Washington"
          },
          {
              "key": "WV",
              "value": "West Virginia"
          },
          {
              "key": "WI",
              "value": "Wisconsin"
          },
          {
              "key": "WY",
              "value": "Wyoming"
          },
          {
              "key": "Other",
              "value": "Other"
          }
        ],
        required: true
      },
      {
        id: 'home_postcode',
        label: 'Zipcode',
        type: 'text',
        control_name: 'home_postcode',
        required: true,
        maxlength: 5,
        pattern: '^[0-9]+$'
      }
    ]
  },
  {
    id: 5,
    name: 'Other Details',
    fields: [
      {
        id: 'extra2',
        label: 'Client Id',
        type: 'text',
        control_name: 'extra2',
        required: false,
        maxlength: 36,
        pattern: '^[a-zA-Z0-9-]+$'
      },
      {
        id: 'preferred_language',
        label: 'Preferred Language',
        type: 'select',
        control_name: 'preferred_language',
        options: [
          {
              "key": "en",
              "value": "English"
          },
          {
              "key": "es",
              "value": "Spanish"
          }
        ],
        required: true,
        default_value: 'en'
      }
    ]
  },
  {
    id: 4,
    name: 'Primary Emergency Contact',
    fields: [
      {
        id: 'emergency_contact',
        label: 'Name',
        type: 'text',
        control_name: 'emergency_contact',
        required: true,
        maxlength: 30,
        pattern: '^.*$'
      },
      {
        id: 'extra3',
        label: 'Relationship',
        type: 'select',
        control_name: 'extra3',
        required: false,
        options: [
            {
                "key" : "Parent",
                "value" : "Parent",
            },
            {
                "key" : "Child",
                "value" : "Child",
            },
            {
                "key" : "Sibling",
                "value" : "Sibling",
            },
            {
                "key" : "Spouse",
                "value" : "Spouse",
            },
            {
                "key" : "Guardian",
                "value" : "Guardian",
            },
            {
                "key" : "Other",
                "value" : "Other",
            }
        ]
      },
      {
        id: 'emergency_phone_day',
        label: 'Primary Phone Number',
        type: 'text',
        control_name: 'emergency_phone_day',
        required: true,
        maxlength: 12,
        pattern: '^\\d{3}-\\d{3}-\\d{4}$'
      },
      {
        id: 'extra4',
        label: 'Type',
        type: 'select',
        control_name: 'extra4',
        required: false,
        options: [
            { key: 'Home', value: 'Home' },
            { key: 'Work', value: 'Work' },
            { key: 'Cell', value: 'Cell' }
        ]
      },
    ]
  },
  {
    id: 4,
    name: 'Primary Emergency Address',
    fields: [
    {
        id: 'emergency_address',
        label: 'Address',
        type: 'longtext',
        control_name: 'emergency_address',
        required: true,
        maxlength: 100,
        pattern: '^.*$'
      },
      {
        id: 'emergency_city',
        label: 'City',
        type: 'text',
        control_name: 'emergency_city',
        required: true,
        maxlength: 30,
        pattern: '^.*$'
      },
      {
        id: 'emergency_state',
        label: 'State',
        type: 'select',
        control_name: 'emergency_state',
        options: [
          {
              "key": "AL",
              "value": "Alabama"
          },
          {
              "key": "AK",
              "value": "Alaska"
          },
          {
              "key": "AZ",
              "value": "Arizona"
          },
          {
              "key": "AR",
              "value": "Arkansas"
          },
          {
              "key": "CA",
              "value": "California"
          },
          {
              "key": "CO",
              "value": "Colorado"
          },
          {
              "key": "CT",
              "value": "Connecticut"
          },
          {
              "key": "DE",
              "value": "Delaware"
          },
          {
              "key": "DC",
              "value": "District of Columbia"
          },
          {
              "key": "FL",
              "value": "Florida"
          },
          {
              "key": "GA",
              "value": "Georgia"
          },
          {
              "key": "HI",
              "value": "Hawaii"
          },
          {
              "key": "ID",
              "value": "Idaho"
          },
          {
              "key": "IL",
              "value": "Illinois"
          },
          {
              "key": "IN",
              "value": "Indiana"
          },
          {
              "key": "IA",
              "value": "Iowa"
          },
          {
              "key": "KS",
              "value": "Kansas"
          },
          {
              "key": "KY",
              "value": "Kentucky"
          },
          {
              "key": "LA",
              "value": "Louisiana"
          },
          {
              "key": "ME",
              "value": "Maine"
          },
          {
              "key": "MD",
              "value": "Maryland"
          },
          {
              "key": "MA",
              "value": "Massachusetts"
          },
          {
              "key": "MI",
              "value": "Michigan"
          },
          {
              "key": "MN",
              "value": "Minnesota"
          },
          {
              "key": "MS",
              "value": "Mississippi"
          },
          {
              "key": "MO",
              "value": "Missouri"
          },
          {
              "key": "MT",
              "value": "Montana"
          },
          {
              "key": "NE",
              "value": "Nebraska"
          },
          {
              "key": "NV",
              "value": "Nevada"
          },
          {
              "key": "NH",
              "value": "New Hampshire"
          },
          {
              "key": "NJ",
              "value": "New Jersey"
          },
          {
              "key": "NY",
              "value": "New York"
          },
          {
              "key": "NM",
              "value": "New Mexico"
          },
          {
              "key": "NC",
              "value": "North Carolina"
          },
          {
              "key": "ND",
              "value": "North Dakota"
          },
          {
              "key": "OH",
              "value": "Ohio"
          },
          {
              "key": "OK",
              "value": "Oklahoma"
          },
          {
              "key": "OR",
              "value": "Oregon"
          },
          {
              "key": "PA",
              "value": "Pennsylvania"
          },
          {
              "key": "RI",
              "value": "Rhode Island"
          },
          {
              "key": "SC",
              "value": "South Carolina"
          },
          {
              "key": "SD",
              "value": "South Dakota"
          },
          {
              "key": "TN",
              "value": "Tennessee"
          },
          {
              "key": "TX",
              "value": "Texas"
          },
          {
              "key": "UT",
              "value": "Utah"
          },
          {
              "key": "VT",
              "value": "Vermont"
          },
          {
              "key": "WA",
              "value": "Washington"
          },
          {
              "key": "WV",
              "value": "West Virginia"
          },
          {
              "key": "WI",
              "value": "Wisconsin"
          },
          {
              "key": "WY",
              "value": "Wyoming"
          },
          {
              "key": "Other",
              "value": "Other"
          }
        ],
        required: true,
      },
      {
        id: 'emergency_postcode',
        label: 'Zipcode',
        type: 'text',
        control_name: 'emergency_postcode',
        required: true,
        maxlength: 5,
        pattern: '^[0-9]+$'
      }
    ]
}
];